import { render, staticRenderFns } from "./CommentForAdminPopup.vue?vue&type=template&id=f156752a&scoped=true"
import script from "./CommentForAdminPopup.vue?vue&type=script&lang=js"
export * from "./CommentForAdminPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f156752a",
  null
  
)

export default component.exports